export const NavData = [
  { title: "Experience", link: "experience" },
  { title: "Skills", link: "skills" },
  { title: "Projects", link: "projects" },
  { title: "Education", link: "education" },
  { title: "Contact", link: "contact" },
];
